import { Navigate, useSearchParams } from 'react-router-dom';
import ResetPasswordPage from './ResetPasswordPage';
import EmailVerificationPage from './EmailVerificationPage';

function AuthActionPage() {
  const [searchParams] = useSearchParams();

  const mode = searchParams.get('mode');
  const oobCode = searchParams.get('oobCode') || '';

  switch (mode) {
    case 'resetPassword':
      return <ResetPasswordPage oobCode={oobCode} />;
    case 'verifyEmail':
      return <EmailVerificationPage oobCode={oobCode} />;
  }

  // todo: Implement other auth mode action here:

  return <Navigate to="/" />;
}

export default AuthActionPage;
